export default {
  SET_IS_TRIAL_ALLOWED(state, v) {
    state.isTrialAllowed = v;
  },

  SET_LOADING: (s, v) => (s.loading = v),
  SET_STEP: (s, n) => (s.currentStep = n),
  SET_USER_TYPE: (s, v) => (s.userType = v),

  SET_BASE_PLAN: (s, id) => (s.basePlanId = id),
  TOGGLE_HUB_PLAN: (s, id) => {
    const i = s.hubPlanIds.indexOf(id);
    i === -1 ? s.hubPlanIds.push(id) : s.hubPlanIds.splice(i, 1);
  },
  SET_DATA_PLAN: (s, id) => (s.dataPlanId = id),
  SET_DATA_PLANS: (s, list) => (s.dataPlans = list || []),

  SET_PAYMENT_METHOD: (s, id) => (s.paymentMethodId = id),
  SET_PAYMENT_METHODS: (s, list) => (s.paymentMethods = list || []),

  SET_COMPANY_TYPE: (s, v) => (s.companyType = v || null),

  UPSERT_PAYMENT_METHOD(s, pm) {
    if (!pm) return;
    const idx = s.paymentMethods.findIndex(
      (x) => String(x.id) === String(pm.id)
    );
    const normalized = {
      id: pm.id,
      card_brand: pm.card_brand ?? pm.brand ?? pm.card?.brand,
      card_ending: pm.card_ending ?? pm.last4 ?? pm.card?.last4,
      card_expires: pm.card_expires ?? pm.expiry ?? null,
      gateway_type: pm.gateway_type ?? null,
      billing: pm.billing ?? null,
    };
    if (idx === -1) s.paymentMethods.push(normalized);
    else s.paymentMethods.splice(idx, 1, normalized);
  },

  SET_ALL_PLANS: (s, v) => {
    s.allPlans = Array.isArray(v) ? v : [];
  },
  SET_COMPANY_PLANS: (s, v) => {
    s.companyPlans = Array.isArray(v) ? v : [];
  },
  SET_TRIAL_ALLOWED: (s, v) => {
    s.isTrialAllowed = !!v;
  },
  SET_COMPANY_FACILITIES: (s, v) => {
    s.companyFacilities = v || [];
  },
  SET_COMPANY_LICENSES(state, list) {
    state.companyLicenses = Array.isArray(list) ? list : [];
  },
  SET_LICENSE_CATEGORY: (s, v) => {
    s.licenseCategory = v || "mixed";
  },

  RESET_WIZARD(s) {
    Object.assign(s, {
      currentStep: 1,
      userType: null,
      basePlanId: null,
      hubPlanIds: [],
      dataPlanId: null,
      paymentMethodId: null,
      isSimulatingNewUser: false,
    });
  },
};
